<template>
  <div class="notificaction-center__notification" :class="notification.status" @mouseover="mouseOver" @mouseleave="mouseleave">
    <div class="notification-center__notification__text">
      <span>{{notification.value}}</span>
      <div class="loading-points" v-if="!notification.remove"><span>.</span><span>.</span><span>.</span></div>
    </div>
    <a class="notification-center__notification__close" v-if="notification.remove" @click="removeNotification">
      <img src="@/assets/close-dark.svg" alt="">
    </a>
  </div>
</template>

<script>
export default {
  props: {
    notification: Object,
    index: Number
  },
  data() {
    return {
      timeout: null
    }
  },
  methods: {
    removeNotification() {
      this.$store.dispatch('removeNotification', this.$props.index)
    },
    mouseOver() {
      clearTimeout(this.timeout);
    },
    mouseleave() {
      this.timeout = setTimeout(() => {
        if (this.notification.remove) this.removeNotification()
      }, 6000);
    }
  },
  created() {
    if (this.$props.notification.remove) {
      this.timeout = setTimeout(() => {
        this.removeNotification()
      }, 6000);
    }
  }
};
</script>

<style lang="scss">
@import '@/styles/_variables';

.notificaction-center__notification {
  display: flex;
  width: fit-content;
  max-width: 400px;
  background: $white;
  border-radius: $redondeado;
  box-shadow: $shadow;
  padding: $margin-base;
  padding-right: $margin-tera;
  margin: $margin-milli 0;
  position: relative;
  font-weight: 600;

  &.error {
    .notification-center__notification__text {
      color: $google;
      font-weight: 600;
    }
  }
  &.success {
    .notification-center__notification__text {
      color: $blue;
      font-weight: 600;
    }
  }

  .notification-center__notification__text {
    @include font-settings(milli,base);
    color: $blue;
    font-weight: 500;

    span {
      margin-right: $margin-milli;
    }
  }

  .notification-center__notification__close {
    position: absolute;
    top: $margin-base;
    right: $margin-base;
    color: $darkgray;
    img {
      width: 14px;
      height: 14px;
    }
  }
}
</style>